export default "__VITE_ASSET__N2w_ExDC__"